import $ from 'jquery';
import React from 'react';
import Chart from "react-google-charts";
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod, GetDateDifferecec,CallMapMethod_CBack} from '../function_lib/common_lib';
import Header from './header';
import Footer from './footer';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Upcoming_Events from '../components/upcoming_events';
import Emp_On_Leave from '../components/emp_on_leave';
import Broadcast from '../components/broadcast';
import Mobile_Widgets from '../components/mobile_widgets';

import './dashboard_new.css';

//import UserManual from '../assets/Operational_Instructions.pdf';

let loginUser="";
let userObject="";
let companyName="";
let userType="";
let clsDashboardNew;
class Comp_Dashboard extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };
    constructor(props){
        super(props);
        clsDashboardNew=this;
        this.state={creditBalance:[]};
        //this.state={no_entities:0,no_clients:0,no_vendors:0}
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        userType="0";
        
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }

      let ret= getAccessFunctions();
      //alert(ret);
     
    }
    getCreditBalance(){
      var map=[];
      map.push({name:"curl_type",value:"getCreditBalance"});
      map.push({name:"res_func",value:"callBackrrr"});
      map.push({name:"local_token",value:userObject[0].app_user_id});
      //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
      
      map["res_func"]="callBackrrr";
      map["curl_type"]="getCreditBalance";
      CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
        //alert(data);
          if(data!=="0" && data!==""){
              let listData=JSON.parse(data);
              var strData="";
              clsDashboardNew.setState({creditBalance:listData},()=>{
                clsDashboardNew.forceUpdateHandler();
              })
            }
      });
}

      componentDidMount(){
        this.getCreditBalance();
        $("#divEmployee").show();
        this.forceUpdateHandler();
      }
   //Get no of Entities/Client/Vendos
     
   
     

    render(){
        return(<div className="wrapper">
            <Header/>
            {/* <Mobile_Widgets/> */}
            <div class="content" style={{"min-height":"150px"}}>
            <div class="container-fluid mt-4">
                   {/* new acta component */}
                   <div className="row">
                    <div className="col-md-8">
                      <div className="row">
                    {/* user compoentnet  */}
            {/* component type */}
           {this.state.creditBalance.map((item,index)=>{
            return(
            <div className="col-md-4">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                  {item.route_name==="WAPP"?<span className="info-box-icon text-cyan bg-info1 elevation-11"><i className="fa fa-comments fa-3x"></i> </span>:""}
                  {item.route_name==="WAPP BUTTON"?<span className="info-box-icon text-green bg-info1 elevation-11"><i className="fa fa-cogs fa-3x"></i></span>:""}
                  {item.route_name==="WAPP API"?<span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cubes fa-3x" aria-hidden="true"></i></span>:""}
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc">{item.route_name}</h5>
              </div>
              <div className="card-footer p-0">
                <ul className="nav flex-column">
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      Total Credits <span className="float-right badge bg-primary">{item.trans_value}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      Used Balance <span className="float-right badge bg-danger">{item.trans_value-item.balance}</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      Available Balance <span className="float-right badge bg-success">{item.balance}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>)
           })} 
            
            {/* end of component tyep */}
</div>
</div>
{/* end of compaign */}
</div>
                {/* end of new acta component */}

{/* <!-- /.content --> */}
</div>
      </div> 
        <Footer/>
        
      </div>)
    }
}
export default Comp_Dashboard